import { TextAnnotationProps } from '@editor/interfaces/canvas/textAnnotation'
import { TextAnnotationLeadAnchor } from '@editor/interfaces/drawing'
import { DEFAULT_STYLES } from '@editor/pages/projects/blueprint-editor/definitions'
import { Vector3 } from 'three'
import { Line2 } from 'three-stdlib'

export const DEFAULT_TEXT_CONFIG: TextAnnotationProps['text'] = {
  color: DEFAULT_STYLES.textColor,
  size: DEFAULT_STYLES.textSize,
}

export const DEFAULT_LINE_CONFIG: TextAnnotationProps['line'] = {
  color: DEFAULT_STYLES.strokeColor,
  style: DEFAULT_STYLES.strokeStyle,
  thickness: DEFAULT_STYLES.strokeWidth,
}

export const DEFAULT_WIDTH = 200
export const MIN_WIDTH = 100
export const MAX_WIDTH = 750

export interface LeadLineAnchors extends TextAnnotationLeadAnchor {
  object: Line2 | null
  midpoint: Vector3
}
